import * as React from "react";

import { LabelMedium, ParagraphMedium } from "kanopi-components/typography";

import { Block } from "baseui/block";
import { ContactUsModal } from "kw/components/ContactUs/ContactUs";
import { Image } from "kanopi-components/Image";
import { QuoteState } from "kw/api/zeus";
import { SidePadder } from "kanopi-components/SpaceWrapper/SidePadder";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";

type TProps = {
  riskProfile?: TRiskProfile;
};

function Referral(props: TProps) {
  const { riskProfile } = props;

  const enabledProductKeys = (riskProfile?.enabledProducts || []).map(
    (product) => product?.key
  );
  const referredQuotes = (riskProfile?.quotes || []).filter(
    (quote) =>
      quote?.state === QuoteState.REFERRED &&
      enabledProductKeys.includes(quote?.product?.key)
  );
  const isReferral = referredQuotes.length > 0;
  const isMultipleReferral = referredQuotes.length > 1;

  return (
    <SidePadder data-testid="referred">
      <Block display="flex" alignItems="center" justifyContent="center">
        <VerticalSpacer maxWidth={["100%", "100%", "100%", "50%"]} alignItems="center">
          <Image
            src={isReferral ? "icon-agent.svg" : "knockout.svg"}
            alt="Agent icon"
            maxWidth="100px"
            strictRatio
            style={{
              marginTop: "32px",
              marginBottom: "32px",
            }}
          />
          <LabelMedium center>We&apos;re sorry for the inconvenience.</LabelMedium>

          <ParagraphMedium center margin="0">
            Based on your previous answer{isReferral && "s"}, we are unable to provide
            you with {isMultipleReferral ? "quotes" : "a quote"}.{" "}
            {isReferral && (
              <>
                Please <ContactUsModal buttonText="contact" /> one of our agents if you
                wish to discuss {isMultipleReferral ? "these quotes" : "this quote"}.
              </>
            )}
          </ParagraphMedium>
          {isReferral && (
            <ParagraphMedium center margin="0">
              Your quote reference number{isMultipleReferral && "s"}:{" "}
              {referredQuotes.map((quote) => (
                <Block key={quote?.product?.key}>
                  <b>#{quote?.id}</b>
                </Block>
              ))}
            </ParagraphMedium>
          )}
        </VerticalSpacer>
      </Block>
    </SidePadder>
  );
}

export { Referral };
